import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";
import {
  fieldErrorsForPrefix,
  useErrDocumentNotReady,
} from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import {
  useVbsConfirmationPatchMutation,
  useVbsConfirmationShowQuery,
} from "@/services/backend/vbs/confirmations/api/confirmation-api";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { PostalAddressCardWithMutation } from "@/services/backend/addresses/components/postal-address-card";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { ServiceContactCardWithMutation } from "@/services/backend/contacts/components/contact-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";

export function AddressesAndContactsRoute() {
  const { confirmationId } = useParams();
  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();
  const {
    data: confirmation,
    isLoading,
    error,
  } = useVbsConfirmationShowQuery({
    id: confirmationId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <PostalAddressCardWithMutation
        id={confirmation!.id}
        address={confirmation!.postalAddress}
        mutation={useVbsConfirmationPatchMutation}
        fieldErrors={fieldErrorsForPrefix(notReadyError, "postalAddress.")}
        resetFieldError={(field) =>
          resetNotReadyErrorField(`postalAddress.${field}`)
        }
        disabled={confirmation!.immutable}
      />
      <ServiceAddressCardWithMutation
        id={confirmation!.id}
        address={confirmation!.serviceAddress}
        mutation={useVbsConfirmationPatchMutation}
        fieldErrors={fieldErrorsForPrefix(notReadyError, "serviceAddress.")}
        resetFieldError={(field) =>
          resetNotReadyErrorField(`serviceAddress.${field}`)
        }
        disabled={confirmation!.immutable}
      />
      <ServiceContactCardWithMutation
        id={confirmation!.id}
        serviceContact={confirmation!.serviceContact}
        mutation={useVbsConfirmationPatchMutation}
        disabled={confirmation!.immutable}
      />
      <RepresentativeCardWithMutation
        id={confirmation!.id}
        representative={confirmation!.representative}
        mutation={useVbsConfirmationPatchMutation}
        fieldErrors={fieldErrorsForPrefix(notReadyError, "representative.")}
        resetFieldError={(field) =>
          resetNotReadyErrorField(`representative.${field}`)
        }
        disabled={confirmation!.immutable}
      />
    </div>
  );
}
